import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiServiceManager';

// eslint-disable-next-line import/prefer-default-export
export const postRestartService = async () => {
  const response = await axiosMethods.post(RestAPI.RESTART_SERVICE);
  return response;
};
